(function () {
  const sections = document.querySelectorAll("[data-ct]");
  if (!sections.length) return;

  sections.forEach((root) => {
    const mobile = root.querySelector("[data-ct-mobile]");
    if (!mobile) return;

    const tabs = Array.from(mobile.querySelectorAll("[data-ct-tab]"));
    const usPanels = Array.from(mobile.querySelectorAll('[data-ct-panel="us"]'));
    const themPanels = Array.from(mobile.querySelectorAll('[data-ct-panel="them"]'));

    function setView(view) {
      tabs.forEach((t) => {
        const on = t.dataset.ctTab === view;
        t.classList.toggle("is-on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });

      const showUs = view === "us";
      usPanels.forEach((p) => (p.hidden = !showUs));
      themPanels.forEach((p) => (p.hidden = showUs));
    }

    tabs.forEach((t) => {
      t.addEventListener("click", () => setView(t.dataset.ctTab));
    });

    setView("us");
  });
})();
